import React from 'react';
import { useTranslation } from 'react-i18next';
import ToolBarButton from "./toolbar-button";

const SyncButton = ({ onSyncClick }) => {
  const { t } = useTranslation();

  return (
    <div className="btn-group px-1">
      <ToolBarButton
      onClick={onSyncClick}
      icon="lf-icon-refresh"
      title={t('topBar.refresh')}
    />
  </div>
);
}

export default SyncButton;
